import React, { useEffect, useState } from 'react';
import Alert from '../../utils/Alert';


const PurchaseOrderCreateLabelAdd = ({scan, item, handleOnAdd, labelError, successMessage }) => {
  const alertRef = React.useRef();

  const [plant, setPlant] = useState('');
  const [plantError, setPlantError] = useState('');

  const [price, setPrice] = useState(item.price);
  const [priceError, setPriceError] = useState('');

  const [barcode, setBarcode] = useState('');
  const [barcodeError, setBarcodeError] = useState('');

  const [weight, setWeight] = useState('');
  const [weightError, setWeightError] = useState('');

  const [packingDate, setPackingDate] = useState('');
  const [packingDateError, setPackingDateError] = useState('');

  const [vendorLotNumber, setVendorLotNumber] = useState('');
  const [vendorLotNumberError, setVendorLotNumberError] = useState('');

  const [numberInventories, setNumberInventories] = useState(1);
  const [numberInventoriesError, setNumberInventoriesError] = useState('');

  useEffect(() => {
    if (labelError !== undefined) {
      if ('barcode' in labelError) setBarcodeError(labelError['barcode'])
      if ('price' in labelError) setPriceError(labelError['price'])
      if ('plant' in labelError) setPlantError(labelError['plant'])
      if ('vendor_lot_number' in labelError) setVendorLotNumberError(labelError['vendor_lot_number'])
      if ('weight' in labelError) setWeightError(labelError['weight'])
      if ('packing_date' in labelError) setPackingDateError(labelError['packing_date'])
      if ('number_inventories' in labelError) setNumberInventoriesError(labelError['number_inventories'])
      if ('message' in labelError) alertRef.current.sendAlert(labelError['message'], "error")
    }
  }, [labelError])

  useEffect(() => {
    if (successMessage !== undefined) {
      setBarcode('')
      cleanErrors()
      if (!scan) resetStates()
      alertRef.current.sendAlert(successMessage, 'success')
    }
  }, [successMessage])

  const cleanErrors = () => {
    setBarcodeError(false)
    setPlantError(false)
    setPriceError(false)
    setVendorLotNumberError(false)
    setWeightError(false)
    setNumberInventoriesError(false)
    setPackingDateError(false)
  }

  const resetStates = () => {
    setWeight('')
    setNumberInventories(1)
  }

  const onPriceChange = (e) => {
    const newPrice = e.target.value
    setPrice(newPrice)
    setPriceError(newPrice < 0 ? 'Price should be a number greater than 0' : false)
  }

  const onPlantChange = (e) => {
    setPlant(e.target.value)
    if (e.target.value) setPlantError(false)
  }

  const onPackingDateChange = (e) => {
    setPackingDate(e.target.value)
    if (e.target.value) setPackingDateError(false)
  }

  const onVendorLotNumberChange = (e) => {
    setVendorLotNumber(e.target.value)
    if (e.target.value) setVendorLotNumberError(false)
  }

  const onWeightChange = (e) => {
    const newWeight = e.target.value
    setWeight(newWeight)
    setWeightError(newWeight < 0 ? 'Weight should be a number greater than 0' : false)
  }

  const onRepeatChange = (e) => {
    const newRepeat = e.target.value
    setNumberInventories(newRepeat)
    setNumberInventoriesError(newRepeat < 0 ? 'Repeat should be an integer greater than 0' : false)
  }

  const onScanLabel = (e) => {
    e.preventDefault()
    if (barcode) {
      handleOnAdd(item.id, barcode, plant, price)
      // Reset form after successful scan
      setBarcode('')
    } else {
      setBarcodeError('Barcode is required')
    }
  }

  const onAddLabel = () => {
    handleOnAdd(item.id, null, plant, price, weight, packingDate || null, vendorLotNumber, numberInventories)
  }

  const price_field = (
    <div key={'price_field'} className={`col-sm-6 form-group row ${priceError && "has-danger"}`}>
      <label className="col-sm-4 col-form-label" htmlFor="text-input">Price</label>
      <div className="col-sm-8 input-group align-items-start">
        <div className="input-group-addon">$</div>
        <input type="number" min={1} className="form-control" placeholder="Price" value={price} onChange={(e) => onPriceChange(e)}/>
      </div>
      {priceError ? <em id="firstname-error" className="error form-control-feedback">{priceError}</em> : <em></em>}
    </div>
  )

  const plant_field = (
    <div key={'plant_field'} className={`col-sm-6 form-group row ${plantError && "has-danger"}`}>
      <label className="col-sm-4 col-form-label" htmlFor="text-input">Plant</label>
      <div className="col-sm-8">
        <input className="form-control" placeholder="Plant" value={plant} onChange={onPlantChange}/>
      </div>
      {plantError ? <em id="firstname-error" className="error form-control-feedback">{plantError}</em> : <em></em>}
    </div>
  )

  const weight_field = (
    <div key={'weight_field'} className={`col-sm-6 form-group row ${weightError && "has-danger"}`}>
      <label className="col-sm-4 col-form-label" htmlFor="text-input">Qty</label>
      <div className="col-sm-8 d-flex flex-nowrap">
        <input className="form-control" placeholder="Weight" value={weight} onChange={(e) => onWeightChange(e)}/>
        <h4 className="ml-1"><span className="badge badge-pill badge-info">{item.measure_unit ? item.measure_unit : 'kg'}</span></h4>
      </div>
      {weightError ? <em id="firstname-error" className="error form-control-feedback">{weightError}</em> : <em></em>}
    </div>
  )

  const vendor_lot_number_field = (
    <div key={'vendor_lot_number_field'} className={`col-sm-6 form-group row ${vendorLotNumberError && "has-danger"}`}>
      <label className="col-sm-4 col-form-label" htmlFor="text-input">Lot</label>
      <div className="col-sm-8">
        <input className="form-control" placeholder="Lot" value={vendorLotNumber} onChange={(e) => onVendorLotNumberChange(e)}/>
      </div>
      {vendorLotNumberError ? <em id="firstname-error" className="error form-control-feedback">{vendorLotNumberError}</em> : <em></em>}
    </div>
  )

  const packing_date_field = (
    <div key={'packing_date_field'} className={`col-sm-6 form-group row ${packingDateError && "has-danger"}`}>
      <label className="col-sm-4 col-form-label" htmlFor="text-input">Packing Date</label>
      <div className="col-sm-8">
        <input type="date" className="form-control" value={packingDate} onChange={(e) => onPackingDateChange(e)}/>
      </div>
      {packingDateError ? <em id="firstname-error" className="error form-control-feedback">{packingDateError}</em> : <em></em>}
    </div>
  )

  const barcode_field = (
    <div key={'barcode_field'} className={`col-sm-6 form-group row ${barcodeError && "has-danger"}`}>
      <label className="col-sm-4 col-form-label" htmlFor="text-input">Barcode</label>
      <div className="col-sm-8">
        <input type="number"
               className="form-control"
               placeholder="Barcode"
               value={barcode}
               onChange={(e) => setBarcode(e.target.value)}
        />
      </div>
      {barcodeError ? <em id="firstname-error" className="error form-control-feedback">{barcodeError}</em> : <em></em>}
    </div>
  )

  const scan_fields = [barcode_field, price_field]
  const non_scan_fields = [price_field, weight_field, vendor_lot_number_field, packing_date_field]
  const fields = scan ? scan_fields : non_scan_fields
  if (item.station === "Butcher") fields.push(plant_field)

  return (
    <div>
      <Alert ref={alertRef}/>
      <h5>New label</h5>
      <div className="row">
        <div className="col-sm-12">
          <div className="card">
            <div className="card-block">
              <form className="row" noValidate onSubmit={(e) => {onScanLabel(e)}}>
                {fields.map((field) => field)}
                <input type="submit" hidden />
              </form>
              {!scan &&
                <div className={`add-repeat-btn ${numberInventoriesError && "has-danger"}`}>
                  <span className="pl-1 pr-05">Repeat</span>
                  <input type="number" className="form-control w-10" min={1} defaultValue="1" value={numberInventories} onChange={onRepeatChange} />
                  <span className="pl-05 pr-1">times</span>
                  <span className="btn btn-danger m-0" onClick={() => onAddLabel()}>Add</span>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PurchaseOrderCreateLabelAdd